import { FunctionComponent, memo } from "react";
import { Option } from "@ppb/the-wall-web";

import styles from "./BspOddsLimit.web.module.css";

type BspOddsLimitViewModel = {
  title: string;
  subtitle?: string;
  isSelected?: boolean;
  checkboxId?: string;
  disabled?: boolean;
  isReadOnly?: boolean;
  onChange?: (isSelected: boolean) => void;
};

const BspOddsLimitComponent: FunctionComponent<BspOddsLimitViewModel> = ({
  title,
  subtitle,
  isSelected = false,
  onChange,
  checkboxId = "bspOddsLimitCheckbox",
  disabled = false,
  isReadOnly = false,
}) => (
  <div className={styles.container}>
    <Option
      title={title}
      subtitle={subtitle}
      isSelected={isSelected}
      isReadOnly={isReadOnly || !onChange}
      disabled={disabled}
      checkboxId={checkboxId}
      onPress={onChange}
    />
  </div>
);

export const BspOddsLimit = memo(BspOddsLimitComponent);
